module.exports = __webpack_public_path__ + "cb7404fe8741cf6117426e3443210f42.MP3";